<template>
  <input type="text"
         placeholder="Search Account..."
         v-on:input="set_value($event.target.value)" />
</template>

<script>
// FIXME: input change isn't reliably triggering on android browser.
//        Always triggers on blur, delete chars, insert chars into
//        middle of string. Looks similar to:
//        https://github.com/vuejs/vue/issues/9299

export default {
  name: 'AccountDirSearch',
  methods :{
    set_value: function(value){
      this.$store.commit('set_accounts_search', value);
    }
  }
}
</script>

<style scoped>
input {
  background: white url('../../assets/search.svg') no-repeat;
  padding-left: 25px;
}
</style>
